export default "__VITE_ASSET__BWl6f_q5__"